// extracted by mini-css-extract-plugin
module.exports = {"page":"_5DjbAEvb","account-profile":"_5D1twwEO","breadcrumbs":"_5D3fpZJi","edit":"_5D4qYqNI","roles":"_5D1rmMRF"};